import { render, staticRenderFns } from "./ReduceAigc.vue?vue&type=template&id=69593ed2&scoped=true"
import script from "./ReduceAigc.vue?vue&type=script&lang=js"
export * from "./ReduceAigc.vue?vue&type=script&lang=js"
import style0 from "./ReduceAigc.vue?vue&type=style&index=0&id=69593ed2&prod&scoped=true&lang=css"
import style1 from "./ReduceAigc.vue?vue&type=style&index=1&id=69593ed2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69593ed2",
  null
  
)

export default component.exports